import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper
} from '@material-ui/core';
import {
  renderMultiLineTextField,
  renderSelectField6
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  CLIENT_SOURCE_OF_INCOME,
  EDUCATION_COMPLETED,
  HOW_MANY_MONTHS_IN_PAST_YEAR,
  NO_YES,
  SUPPORT_SYSTEM,
  
  buildOptions_NumberOfChildren,
} from '../../../../actions/action-constants';
class FormFieldsIntakeAssessSoclDtrntFctrsOrntnAsmnt extends Component {
  render () {
    return (
      <div>

        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientisveteran'
                    name='clientisveteran'
                    label='Client Is A Veteran'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='limitedenglishproficiency'
                    name='limitedenglishproficiency'
                    label='Limited English Proficiency'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='limitedenglishproficiencycomments'
                    name='limitedenglishproficiencycomments'
                    label='Limited English Proficiency Comments'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={EDUCATION_COMPLETED}
                    id='educationcompleted'
                    name='educationcompleted'
                    label='Education Completed'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={HOW_MANY_MONTHS_IN_PAST_YEAR}
                    id='clienthomelesshowmanyweekspastyear'
                    name='clienthomelesshowmanyweekspastyear'
                    label='Client Homeless How Many Weeks Past Year'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={HOW_MANY_MONTHS_IN_PAST_YEAR}
                    id='clientemployedhowmanyweekspastyear'
                    name='clientemployedhowmanyweekspastyear'
                    label='Client Employed How Many Weeks Past Year'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_SOURCE_OF_INCOME}
                    id='clientsourceofincome'
                    name='clientsourceofincome'
                    label='Client Source of income'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={SUPPORT_SYSTEM}
                    id='supportsystem'
                    name='supportsystem'
                    label='Support System'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='supportsystemcomments'
                    name='supportsystemcomments'
                    label='Support System Comments'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={buildOptions_NumberOfChildren()}
                    id='numberofchildren'
                    name='numberofchildren'
                    label='Number of Children Under 18 years old'
                  />
                </Grid>
              </Grid> 

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientintakeandassessmentcomments'
                    name='clientintakeandassessmentcomments'
                    label='Client Intake and Assessment Comment'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>
      </div>
    )
  }
}
FormFieldsIntakeAssessSoclDtrntFctrsOrntnAsmnt.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsIntakeAssessSoclDtrntFctrsOrntnAsmnt
